
// 外部依赖
import * as _ from 'lodash'
import { FormatAddOne } from '@/utils/Time'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
// @ts-ignore
import { saveAs } from 'file-saver'
// api
import {
  getOrder,
  getVerifyDeliver,
  getSeewoZipList,
  rerunWord2FbdOrder,
  rerunStu2TeaOrder,
  rerunOrderStatus,
  getDraftingImageList,
  getDraftingProjectInfo,
  editDraftingProject,
  creatGalleryProject,
  reRunWord2PPTTask,
  getDeductPoint,
  reRunJSON2PPTTask,
  getServiceType,
  getDeductRatio,
} from '@/api/Allservices'
import { getSubject, getStage, getGrade } from '@/api/education'
// 工具函数
import { removeEmpty } from '@/utils/helper'
// types
import { ElTable } from 'element-ui/types/table'
import { IOrderObject } from '@/types/orderDetail'
import { IConfig } from '@/types/placeOrderTypes'
import { isArray } from '@/utils/validate'
import { IDeliver } from '@/types/service'
// 定义的服务数据
import {
  IService,
  serviceByToolList,
  serviceList,
  serviceListContent,
  serviceByToolListContent,
} from '@/business/ServiceContent'
import { IDefaultConfigData } from '@/business/DefaultConfigData'
import ConfigForm from '../../placeOrder/components/ConfigForm.vue'
import OrderDetail from './OrderDetail.vue'
import DraftingList from './DraftingList.vue'
import { getOrgInfoByOId, own } from '@/api/login'
import { debounce } from 'lodash'
import dayjs from 'dayjs'
import { RepeatedAsyncExecutor } from '@/utils/RepeatedAsyncExecutor'
import { createOptionsOrigin, serviceTypeMap, statusTypeMap, statusOptions } from './config'
import { ZipDownloader, downloadBlob, DownloadFile } from '@/utils/zipDownloader'
import { getPageCount } from './utils'

interface IConditions {
  page: number
  limit: number
  status: string | number
  status_str: string
  alias: string
  service_content: string | number
  hidden_close: boolean
  subject?: string
  sort?: string
}
@Component({
  components: {
    ConfigForm,
    DraftingList,
    OrderDetail,
  },
})
export default class OrderList extends Vue {
  @Action('setEduInfo') setEduinfo: any
  @Action('setUser') setUser: any
  @Getter('eduInfo') eduInfo: any
  @Getter('user') user: any

  getErrorInfo(errorInfo: string) {
    if (errorInfo.includes('答案册试题册数量差异过大')) {
      return (
        errorInfo.match(/答案册试题册数量差异过大，请检查（试题册：\d+，答案册：\d+）/gim)?.[0] ||
        '答案册试题册数量差异过大，请检查'
      )
    }
    if (errorInfo.includes('存在不符合规范的题号')) {
      return '存在不符合规范的题号，请检查是否存在连续超过200个的题号'
    }
    if (errorInfo.includes('gb18030')) {
      return '文件存在无法解析的字符，请检查是否文件存在加密或者使用了非gb18030字符集的字符'
    }
    if (errorInfo.includes('处理标注 word 文档时出错: File is not a zip file;')) {
      return '请解密再上传'
    }
    return '文件处理异常，请在微信服务群中进行咨询。'
  }

  get subjects() {
    if (this.eduInfo) {
      return this.eduInfo.subject || []
    }
    return []
  }
  // 获取状态文本
  getStatusText(status: number): string {
    if (status > 3 && status < 8) return '制作中'
    return statusTypeMap[status as keyof typeof statusTypeMap].text
  }

  // 获取状态颜色
  getStatusColor(status: number): string {
    if (status > 3 && status < 8) return '#2b78e4'
    return statusTypeMap[status as keyof typeof statusTypeMap].color
  }

  // 获取状态名称
  getServiceTypeName(serviceContent: any): string {
    return serviceTypeMap[serviceContent as keyof typeof serviceTypeMap] || '未知服务'
  }

  // 获取扣点
  getPageCount(row: IOrderObject) {
    if ([30, 31].includes(row.service_content!)) {
      return '未扣点'
    }
    return getPageCount(row, this.ratioMap)
  }

  // 获取下载按钮类型
  getDownloadButtonType(row: IOrderObject): string {
    return row.status !== 8 ? '' : 'success'
  }

  // 获取下载按钮禁用状态
  getDownloadButtonDisabled(row: IOrderObject): boolean {
    return row.status !== 8
  }

  // 获取下载按钮点击事件
  getDownloadButtonAction(row: IOrderObject) {
    if (row.service_content && [4, 16, 25, 24].includes(row.service_content)) {
      return this.downloadDelivery(row)
    } else if (row.service_content && [30, 31].includes(row.service_content)) {
      return this.downloadAI(row)
    }
    return this.openDelivery(row)
  }
  // 判断来源域名
  get isFromExternalDomain() {
    // 获取当前域名
    const currentDomain = process.env.VUE_APP_AI_HOST
    const currentHostname = window.location.hostname
    // 如果来源域名为空或与当前域名相同，则认为是从本域名跳转
    return currentHostname && currentHostname == currentDomain
  }

  // 学科去重
  get subjectsList() {
    if (this.subjects) {
      const res: any[] = []
      this.subjects.map((cur: any) => {
        if (!res.find(item => item.subject === cur.subject)) {
          res.push(cur)
        }
      })
      return res || []
    }
    return []
  }

  get stages() {
    if (this.eduInfo) {
      return this.eduInfo.stage || []
    }
    return []
  }

  get orgId() {
    return this.$store.state.user?.orgs[0]?.orgId || 0
  }

  get userOptions() {
    return this.$store.state.user?.orgs[0] || {}
  }

  get hasExpiredTip() {
    return this.deliver && this.OTHER.length && !this.OTHER?.[0]?.expiration
  }

  get statusOptions() {
    return statusOptions
  }

  get serviceListContent() {
    return serviceListContent
  }

  get serviceByToolListContent() {
    return serviceByToolListContent
  }

  tableLoading = false
  entries: number[] = []
  // Zip下载器相关属性
  zipDownloader: ZipDownloader | null = null
  ratioMap = {
    pdf2fbd: 0.5,
    pdf2word: 0.5,
    pdf2word_fbd: 0.5,
    word2fbd: 0.5,
    aiedit: 1.5,
    aitag: 1.5,
  }
  async activated() {
    window.addEventListener('resize', this.resize)

    let entries = [0, 2, 3, 5, 9]
    let OrgInfo
    if (this.$store.state.OrgInfo) {
      OrgInfo = this.$store.state.OrgInfo
    } else {
      OrgInfo = await getOrgInfoByOId({ orgId: this.orgId })
    }

    if (OrgInfo.entries && OrgInfo.entries.length)
      entries = OrgInfo.entries.split(',').map((item: string) => Number(item))
    this.entries = entries
    await this.getEntries()
    this.condistions.service_content = this.entries.join(',')

    await this.getFilterList()
    this.listExecutor.restart(false)

    await this.getEduInfo()
    // 获取扣点比例
    await this.fetchDeductRatios()
    this.$nextTick(() => {
      ;(this.$refs.dataTable as ElTable)?.doLayout()
    })
  }
  orderList: IOrderObject[] = []
  count = 0
  async getEduInfo() {
    const storage = window.localStorage
    try {
      const localSubject = JSON.parse(storage.getItem('subject') as string)
      const localStage = JSON.parse(storage.getItem('stage') as string)
      const localGrade = JSON.parse(storage.getItem('grade') as string)
      if (
        isArray(localSubject) &&
        isArray(localStage) &&
        isArray(localGrade) &&
        localSubject.length &&
        localStage.length &&
        localGrade.length
      ) {
        this.setEduinfo({
          subject: localSubject,
          grade: localGrade,
          stage: localStage,
        })
        return
      } else {
        throw new Error('get eduInfo')
      }
    } catch (error) {
      const [subject, stage, grade] = await Promise.all([getSubject({}), getStage({}), getGrade({})])
      if (
        !storage.getItem('subject') ||
        storage.getItem('subject') === 'null' ||
        storage.getItem('subject') === 'undefined' ||
        !storage.getItem('subject')?.length
      ) {
        storage.setItem('subject', JSON.stringify(subject))
      }
      if (
        !storage.getItem('stage') ||
        storage.getItem('stage') === 'null' ||
        storage.getItem('stage') === 'undefined' ||
        !storage.getItem('stage')?.length
      ) {
        storage.setItem('stage', JSON.stringify(stage))
      }
      if (
        !storage.getItem('grade') ||
        storage.getItem('grade') === 'null' ||
        storage.getItem('grade') === 'undefined' ||
        !storage.getItem('grade')?.length
      ) {
        storage.setItem('grade', JSON.stringify(grade))
      }
      this.setEduinfo({
        subject,
        grade,
        stage,
      })
    }
  }

  // 获取实际扣点比例
  async fetchDeductRatios() {
    try {
      // 使用 Promise.all 并行获取所有比率
      const [pdf2fbd, pdf2word, pdf2word_fbd, word2fbd, aiedit, aitag] = await Promise.all([
        getDeductRatio({ service_content: 24, delivery: 4 }),
        getDeductRatio({ service_content: 24, delivery: 1 }),
        getDeductRatio({ service_content: 24, delivery: 21 }),
        getDeductRatio({ service_content: 16, delivery: 9 }),
        getDeductRatio({ service_content: 30, delivery: 1 }),
        getDeductRatio({ service_content: 31, delivery: 1 }),
      ])

      // 更新比率映射对象
      this.ratioMap = {
        pdf2fbd: pdf2fbd || 0.5,
        pdf2word: pdf2word || 0.5,
        pdf2word_fbd: pdf2word_fbd || 0.5,
        word2fbd: word2fbd || 0.5,
        aiedit: aiedit || 1.5,
        aitag: aitag || 1.5,
      }
    } catch (error) {
      console.error('获取扣点比例失败:', error)
      // 出错时保留默认值
    }
  }

  // 获取客户已下单的订单类型
  async getEntries() {
    const res = await getServiceType()
    if (res && res.length > 0) {
      // 获取this.entries和res的交集
      this.entries = res.filter((item: number) => this.entries.some(entry => entry == item))
    }
  }
  // 服务类型筛选
  get options() {
    if (this.entries.join(',').length > 0) {
      return createOptionsOrigin(this.entries.join(',')).filter(
        item => item.label == '全部类型' || this.entries.includes(Number(item.value)),
      )
    }
  }
  // 状态筛选
  selectStatus = ''
  oldCondistions: any = null
  // 处理状态筛选
  handleStatusSelect(selectStatus: number) {
    if (selectStatus === 4) {
      this.condistions.status_str = 'make'
      this.condistions.status = ''
    } else {
      this.condistions.status = selectStatus
      this.condistions.status_str = ''
    }
  }
  // 分页、筛选相关
  condistions: IConditions = {
    page: 1,
    limit: 15,
    status: '',
    status_str: '',
    alias: '',
    service_content: '',
    hidden_close: true,
    subject: '',
    sort: 'create_time',
  }
  @Watch('condistions', { deep: true })
  async list(newVal: any) {
    const oldValue = this.oldCondistions
    this.oldCondistions = _.cloneDeep(newVal)
    if (newVal.alias === oldValue?.alias) {
      if (
        newVal.service_content !== oldValue?.service_content ||
        newVal.status !== oldValue?.status ||
        newVal.subject !== oldValue?.subject ||
        newVal.limit !== oldValue?.limit
      ) {
        this.condistions.page = 1
      }
      console.log('请求')
      await this.debounceGetList()
    }
  }

  async resetPage() {
    await this.debounceGetList()
    this.condistions.page = 1
  }

  async getList() {
    await this.getFilterList()
    this.listExecutor.restart(false)
  }

  listExecutor = new RepeatedAsyncExecutor<boolean>(this.getFilterList, 5000)
  debounceGetList = debounce(this.getList, 500, { leading: true })

  async getFilterList(loading = true) {
    if (this.$store.state.organization) {
      if (loading) {
        this.tableLoading = true
      }
      const { id } = this.$store.state.organization
      const obj = removeEmpty(this.condistions)
      // 兼容查询工单tick-id
      const reg = /^[a-z0-9]{24}$/
      if (obj.alias && reg.test(obj.alias.trim())) {
        obj.ticket_id = obj.alias.trim()
        delete obj.alias
      }
      const res = await getOrder({
        customer_id: id,
        ...obj,
        // hidden_company: true,
      })
      this.orderList = res.tickets
      this.count = res.count

      this.$nextTick(() => {
        ;(this.$refs.dataTable as ElTable)?.doLayout()
      })
      setTimeout(() => {
        this.tableLoading = false
      }, 300)
    }
  }

  handleResize() {
    this.$nextTick(() => {
      ;(this.$refs.dataTable as ElTable)?.doLayout()
    })
  }
  resize = _.debounce(this.handleResize, 100)

  // 展开服务类型
  service = [...serviceList, ...serviceByToolList].reduce((pre, next) => {
    return pre.concat(next.list)
  }, [] as IService[])
  // 继续下单
  proceedOrder(row: IOrderObject) {
    const id = row.ticket_id
    const service = this.service.find(item => item.service_content === row.service_content)!
    window.sessionStorage.setItem('service_type', service.mapKey)
    window.sessionStorage.setItem('service_name', service.name)
    this.$router.push({
      name: 'create',
      query: {
        id,
      },
      params: {
        serviceType: service.mapKey,
        name: service.name,
      },
    })
  }
  // 订单详情
  detailVisible = false
  detailOrder: IOrderObject | null = null
  openDetail(row: IOrderObject) {
    this.detailOrder = row
    this.detailVisible = true
  }
  clearDetail() {
    this.detailOrder = null
  }
  // 下载结果
  deliveryVisible = false
  deliverLoading = false
  deductPointTypeMap: { [key: number]: string } = {
    16: 'word',
    19: 'json',
    25: 'ppt',
  }

  currentRow: IOrderObject | null = null
  async openDelivery(row: IOrderObject) {
    this.currentRow = row
    this.deliverLoading = true
    this.deliver = await this.getDeliver(row)
    this.deliverLoading = false
    this.deliveryVisible = true
  }

  async downloadDelivery(row: IOrderObject) {
    let rowCount = await getPageCount(row, this.ratioMap)

    if (rowCount <= 0) {
      return this.$message.error('PPT页数生成失败,请联系管理员!')
    }

    if (!row.is_pay) {
      const userPoints = +this.user?.orgs[0].wordPoints || 0

      if (userPoints - rowCount < 0) {
        return this.$confirm('您的账号剩余页数不足，请联系管理人员！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
        })
      }
      // 积分足够
      const confirm = await this.$confirm(
        `您的账户剩余下载点数为 ${userPoints}，扣除当前下载点数 ${rowCount}，扣除完剩余 ${
          userPoints - rowCount
        } 点，是否确认下载`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).catch(() => false)
      // 用户取消下载
      if (!confirm) return
    }

    // 获取交付数据
    const res = await this.getDeliver(row)

    // 根据服务类型提取对应的交付物
    let delivery = null
    if (row.service_content == 24) {
      delivery = []
      if (res.PDF2FBD) delivery.push(...res.PDF2FBD)
      if (res.WORD2FBD) delivery.push(res.WORD2FBD?.[res.WORD2FBD?.length - 1])
    } else if (row.service_content == 16) {
      delivery = res.WORD2FBD?.[res.WORD2FBD.length - 1]?.word2fbd?.[0] || res.WORD2FBD?.[res.WORD2FBD?.length - 1]
    } else if (row.service_content == 25) {
      delivery = res.PPT2SEEWO
    } else {
      // ai相关的服务
      delivery = res.XDOC
    }

    // 执行下载
    if (Array.isArray(delivery)) {
      if (delivery.length > 0) {
        this.deliveryVisible = true
        this.deliver = res
        this.currentRow = row
      } else {
        this.$message.error('无可用交付物，下载失败！')
      }
    } else if (delivery) {
      if (delivery.adjust_url) {
        await this.download(row, delivery.adjust_url, delivery.task_name + '.zip')
      } else if (delivery.zip_url) {
        await this.download(row, delivery.zip_url, delivery.task_name + '.zip')
      } else {
        this.$message.error('下载失败！请联系管理员。')
      }
    } else {
      this.$message.error('无可用交付物，下载失败！')
    }

    // 扣除积分
    if (!row.is_pay) {
      await getDeductPoint({
        ticket_id: row.ticket_id,
        point_type:
          row.service_content === 30 || row.service_content === 31
            ? 'question_count'
            : row.service_content === 24
            ? 'pdf'
            : row.service_content === 25
            ? 'ppt_seewo'
            : 'word',
      })
      await this.getFilterList()
      await this.getUserInfo()
    }
  }

  async downloadAI(row: IOrderObject) {
  // 判断订单是否需要扣费
  // const is_not_deduct_point = row.status === 8 && (new Date(row.publish_time!).getTime() - new Date(row.place_order_time!).getTime() > 15 * 60 * 1000)
    // 扣除积分
    // if (!row.is_pay && !is_not_deduct_point) {
    if (!row.is_pay) {
      try {
        const res = await this.getDeliver(row)
        const question_count = res?.XDOC?.[0]?.question_count || 0
        const rowCount =
          row.service_content === 30 ? question_count * this.ratioMap.aiedit : question_count * this.ratioMap.aitag
        const userPoints = +this.user?.orgs[0].wordPoints || 0

        if (userPoints - rowCount < 0) {
          return this.$confirm('您的账号剩余页数不足，请联系管理人员！', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false,
          })
        }
        // 积分足够
        const confirm = await this.$confirm(
          `扣除下载点数 ${rowCount}，是否确认下载`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).catch(() => false)
        if (!confirm) return

        await getDeductPoint({
          ticket_id: row.ticket_id,
          point_type: 'question_count',
        })
        await this.getFilterList()
        await this.getUserInfo()

        this.deliveryVisible = true
        this.deliver = res
        this.currentRow = row
      } catch (e) {
      }
    } else {
      const res = await this.getDeliver(row)
      this.deliveryVisible = true
      this.deliver = res
      this.currentRow = row
    }
  }

  async getUserInfo() {
    const res = await own()
    await this.setUser(res)
  }

  deliver: IDeliver | null = null
  async getDeliver(row: IOrderObject) {
    try {
      // Todo: 新增PDF2WORD的标识
      const services: [number, string][] = [
        [9, 'WORD'],
        [10, 'STU2TEA'],
        [11, 'WORD2FBD'],
        [12, 'TOGRAY'],
        [13, 'TOCOLOR'],
        [14, 'TODIFF'],
        [15, 'TOSR'],
        [16, 'WORD2FBD'],
        [17, 'TOSR2'],
        [18, 'WORD2PPT'],
        [19, 'JSON2PPT'],
        [24, 'PDF2FBD'],
        [25, 'PPT2SEEWO'],
        [30, 'XDOC'],
        [31, 'XDOC'],
      ]
      let process_name = services.find(s => s[0] === row.service_content)?.[1]
      if (process_name === 'WORD') {
        process_name = 'OTHER'
      }
      let res = await getVerifyDeliver({
        ticket_id: row.ticket_id,
        process_name,
      })

      if(process_name == 'PPT2SEEWO' && row.xdoc_planning[0].extra[0].business_project_id){
        res = await this.getDeliverWithPath(row.xdoc_planning[0].extra[0].business_project_id,res)
      }

      return res
    } catch (error) {
      return null
    }
  }

  async getDeliverWithPath(project_id: string,delivery_res: any) {
    const res = await getSeewoZipList({
      project_id: project_id,
    })
    let delivery_data = delivery_res.PPT2SEEWO
    let delivery_with_path_data = res.data

    if (delivery_data && Array.isArray(delivery_data) &&
        delivery_with_path_data && Array.isArray(delivery_with_path_data)) {
      
      delivery_data.forEach((deliveryItem: any) => {
        const matchingPathItem = delivery_with_path_data.find((pathItem: any) => 
          pathItem.result_url === deliveryItem.url
        )
        
        // 用 '/' 拼接后赋值给 name,后面压缩会根据 '/' 创建文件夹
        if (matchingPathItem && matchingPathItem.path && Array.isArray(matchingPathItem.path)) {
          deliveryItem.name = matchingPathItem.path.join('/')
        }
      })
    }

    return {PPT2SEEWO:delivery_data};
  }

  get OTHER() {
    const { deliver } = this

    if (deliver && Array.isArray(deliver.OTHER) && deliver.OTHER.length) {
      return deliver.OTHER
    }
    return []
  }

  get STU2TEA() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.STU2TEA) && deliver.STU2TEA.length) {
      const len = deliver.STU2TEA.length - 1
      return (deliver.STU2TEA?.[len] as any)?.stu2tea || deliver.STU2TEA
    }
    return []
  }

  get WORD2FBD() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.WORD2FBD) && deliver.WORD2FBD.length) {
      const len = deliver.WORD2FBD.length - 1
      return (deliver.WORD2FBD?.[len] as any)?.word2fbd || deliver.WORD2FBD
    }
    return []
  }

  get TOGRAY() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.TOGRAY) && deliver.TOGRAY.length) {
      return deliver.TOGRAY
    }
    return []
  }

  get TOCOLOR() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.TOCOLOR) && deliver.TOCOLOR.length) {
      return deliver.TOCOLOR
    }
    return []
  }

  get TODIFF() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.TODIFF) && deliver.TODIFF.length) {
      return deliver.TODIFF
    }
    return []
  }

  get TOSR() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.TOSR) && deliver.TOSR.length) {
      return deliver.TOSR
    }
    return []
  }

  get TOSR2() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.TOSR2) && deliver.TOSR2.length) {
      return deliver.TOSR2
    }
    return []
  }

  get WORD2PPT() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.WORD2PPT) && deliver.WORD2PPT.length) {
      const len = deliver.WORD2PPT.length - 1
      return (deliver.WORD2PPT?.[len] as any)?.word2ppt || deliver.WORD2PPT
    }
    return []
  }

  get JSON2PPT() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.JSON2PPT) && deliver.JSON2PPT.length) {
      const len = deliver.JSON2PPT.length - 1
      return (deliver.JSON2PPT?.[len] as any)?.JSON2PPT || deliver.JSON2PPT
    }
    return []
  }

  get PPT2SEEWO() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.PPT2SEEWO) && deliver.PPT2SEEWO.length) {
      const len = deliver.PPT2SEEWO.length - 1
      return (deliver.PPT2SEEWO?.[len] as any)?.PPT2SEEWO || deliver.PPT2SEEWO
    }
    return []
  }

  // 批量下载PPT2SEEWO文件并打包成zip
  async downloadPPT2SEEWOAsZip() {
    if (!this.deliver || !this.deliver.PPT2SEEWO || !Array.isArray(this.deliver.PPT2SEEWO)) {
      this.$message.error('没有可下载的PPT2SEEWO文件')
      return
    }
    this.$message.success('开始下载PPT2SEEWO文件...')
    const files: DownloadFile[] = []

    // 从deliver.PPT2SEEWO中提取所有文件
    this.deliver.PPT2SEEWO.forEach((item: any, index: number) => {
      if (item.url) {
        let fileName = item.task_name || item.name || `PPT2SEEWO_${index + 1}`
        // 将文件后缀名从ppt、pptx改为enbx
        fileName = fileName.replace(/\.(ppt|pptx)$/i, '.enbx')

        files.push({
          url: item.url,
          name: fileName,
          task_name: item.task_name
        })
      }
    })

    if (files.length === 0) {
      this.$message.error('没有找到有效的下载链接')
      return
    }

    try {
      this.deliverLoading = true

      // 初始化zip下载器
      if (!this.zipDownloader) {
        this.zipDownloader = new ZipDownloader()
      }

      const zipName = `${(this.currentRow?.alias.endsWith('.zip')?this.currentRow?.alias:this.currentRow?.alias+'.zip') || 'files.zip'}`

      this.zipDownloader.downloadAndZip(files, zipName, {
        onProgress: (progress) => {
          if (progress.type === 'WARNING') {
            this.$message.warning(progress.message)
          }
        },
        onComplete: (blob, fileName) => {
          this.deliverLoading = false
          downloadBlob(blob, fileName)
          this.$message.success('打包下载完成！')
        },
        onError: (error) => {
          this.deliverLoading = false
          this.$message.error(`下载失败: ${error}`)
        }
      })
    } catch (error) {
      this.deliverLoading = false
      this.$message.error('下载过程中发生错误，请重试')
      console.error('ZIP下载错误:', error)
    }
  }

  get PDF2FBD() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.PDF2FBD) && deliver.PDF2FBD.length) {
      let group = [
        {
          task_name: '',
          zip_url: '',
          word_files: [],
        },
      ]
      deliver.PDF2FBD.forEach(item => {
        if (item.zip_url) {
          group[0] = {
            ...group[0],
            ...item,
          }
        }
        if (item.word_url && group[0].word_files.length === 0) {
          ;(group[0].word_files as any).push(item)
        }
      })
      return group
    }
    return []
  }

  get AIEDIT() {
    const { deliver } = this
    if (deliver && Array.isArray(deliver.XDOC) && deliver.XDOC.length) {
      const len = deliver.XDOC.length - 1
      return (deliver.XDOC?.[len] as any)?.XDOC || deliver.XDOC
    }
    return []
  }

  clearDelivery() {
    this.deliveryVisible = false
  }
  copyAllLinks(res: any) {
    if (!res.filter((item: any) => item.url).length) return this.$message.warning('暂无链接生成')

    let text = ''
    res
      .filter((item: any) => item.url)
      .forEach((item: any) => {
        text += `${item.url}\n\n`
      })
    const allLinks = text
    const textArea = document.createElement('textarea')
    textArea.style.position = 'fixed'
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.width = '2em'
    textArea.style.height = '2em'
    textArea.style.padding = '0'
    textArea.style.border = 'none'
    textArea.style.outline = 'none'
    textArea.style.boxShadow = 'none'
    textArea.style.background = 'transparent'
    textArea.value = `${allLinks}`
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      this.$message.success(`成功复制 ${res.filter((item: any) => item.url).length} 个链接`)
    } catch (err) {
      this.$message.error('复制失败,该浏览器不支持点击复制到剪贴板')
    }
    document.body.removeChild(textArea)
  }
  // 复制到剪贴板
  copyToClipboard(text: string) {
    const textArea = document.createElement('textarea')
    textArea.style.position = 'fixed'
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.width = '2em'
    textArea.style.height = '2em'
    textArea.style.padding = '0'
    textArea.style.border = 'none'
    textArea.style.outline = 'none'
    textArea.style.boxShadow = 'none'
    textArea.style.background = 'transparent'
    textArea.value = `${text}?time=${dayjs().valueOf()}`
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      this.$message.success('复制成功')
    } catch (err) {
      this.$message.error('复制失败,该浏览器不支持点击复制到剪贴板')
    }
    document.body.removeChild(textArea)
  }
  // 直接下载 -
  async download(row: any, url: string, name?: string) {
    try {
      if (name) saveAs(`${url}?time=${dayjs().valueOf()}`, name)
      // else if (row.file_name) saveAs(`${url}?time=${dayjs().valueOf()}`, row.file_name);
      // else if (row.task_name) saveAs(`${url}?time=${dayjs().valueOf()}`, row.task_name);
      else this.downloadOrigin(`${url}?time=${dayjs().valueOf()}`)
    } catch (e) {
      this.$message.error('下载异常，请联系管理人员！')
    }
  }
  // 浏览器直接直接下载
  downloadOrigin(url: string) {
    const a = document.createElement('a')
    a.href = url
    a.click()
  }
  // 销毁前
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }

  deactivated() {
    this.listExecutor.stop()
    window.removeEventListener('resize', this.resize)
    // 清理zip下载器
    if (this.zipDownloader) {
      this.zipDownloader.destroy()
      this.zipDownloader = null
    }
  }

  configVisible = false
  projectConfig: IConfig | null = null

  openConfig(config: IConfig) {
    this.projectConfig = config
    this.configVisible = true
  }

  clearConfig() {
    this.projectConfig = null
  }

  async saveConfigHandle(config: IDefaultConfigData) {
    if (this.projectConfig) {
      this.projectConfig.stu2tea_config = config
    }
    // await editOrder(formData);
    this.projectConfig = null
    this.configVisible = false
  }

  async rerunOrderHandle(row: IOrderObject) {
    try {
      if (row.service_content === 10) {
        await rerunStu2TeaOrder({
          ticket_id: row.ticket_id,
          run_type: 'rerun',
        })
      } else {
        await rerunWord2FbdOrder({
          ticket_id: row.ticket_id,
          run_type: 'rerun',
        })
      }
      await rerunOrderStatus({
        ticket_id: row.ticket_id,
        status: row.status,
      })
      this.$message.success('重跑成功')
    } catch (error) {
      console.log(error)
    }
  }

  /**
   * word2ppt 重跑
   * @param row
   */
  async reRunW2P(row: IOrderObject) {
    try {
      await Promise.all([
        reRunWord2PPTTask({ ticket_id: row.ticket_id }),
        rerunOrderStatus({
          ticket_id: row.ticket_id,
        }),
      ])
      this.orderList = this.orderList.map((v: IOrderObject) => {
        if (v.ticket_id === row.ticket_id) {
          v.status = 5
        }
        return v
      })
      this.$notify({
        message: '重跑成功',
        title: '成功',
        type: 'success',
      })
    } catch (e) {
      this.$notify({
        message: '重跑失败',
        title: '失败',
        type: 'error',
      })
    }
  }

  /**
   * json2ppt 重跑
   * @param row
   */
  async reRunJ2P(row: IOrderObject) {
    try {
      await Promise.all([
        reRunJSON2PPTTask({ ticket_ids: [row.ticket_id] }),
        rerunOrderStatus({ ticket_id: row.ticket_id }),
      ])
      this.orderList = this.orderList.map((v: IOrderObject) => {
        if (v.ticket_id === row.ticket_id) {
          v.status = 5
        }
        return v
      })
      this.$notify({
        message: '重跑成功',
        title: '成功',
        type: 'success',
      })
    } catch (e) {
      this.$notify({
        message: '重跑失败',
        title: '失败',
        type: 'error',
      })
    }
  }

  editRerunOrderHandle(row: IOrderObject) {
    if (row.service_content === 10) {
      window.sessionStorage.setItem('service_type', 'studentToTeacher')
      window.sessionStorage.setItem('service_name', '学用转教用')
    } else if (row.service_content === 11) {
      window.sessionStorage.setItem('service_type', 'wordToFbd')
      window.sessionStorage.setItem('service_name', 'Word转方正书版')
    } else {
      window.sessionStorage.setItem('service_type', 'wordToFbd_auto')
      window.sessionStorage.setItem('service_name', 'Word转方正书版-自动')
    }
    // 跳转去对应的id create页面
    this.$router.push(`/create?id=${row.ticket_id}&fbd_config_visible=0&reEdit=true`)
  }

  draftingVisible = false
  draftingData: {
    image_task_requirement?: string
    image_task_sample?: []
    image_list?: []
  } = {}
  draftingOrder: IOrderObject | null = null
  draftingProjectId = ''
  timer: any = null

  async openDrafting(row: IOrderObject) {
    const project_info = await getDraftingProjectInfo({
      platform_id: row.ticket_id,
    })
    this.draftingProjectId = project_info._id
    this.draftingData.image_task_requirement = project_info.desc
    this.draftingData.image_task_sample = project_info.sample_path
    const image_list = await getDraftingImageList({
      platform_id: row.ticket_id,
    })
    this.draftingData.image_list = image_list
    if (image_list.length) {
      this.updateImageListLoop()
    }
    this.draftingOrder = row
    this.draftingVisible = true
  }

  updateImageListLoop() {
    if (this.timer) {
      return
    }
    this.timer = setInterval(async () => {
      this.updateImageList()
    }, 10000)
  }

  async updateImageList() {
    const image_list = await getDraftingImageList({
      platform_id: this.draftingOrder?.ticket_id,
    })
    this.draftingData.image_list = image_list
  }

  clearDrafting() {
    this.draftingProjectId = ''
    this.draftingOrder = null
    this.draftingData = {}
    clearInterval(this.timer)
    this.timer = null
  }

  async CreatGalleryProjectHandle(desc: string, sample_path: [], image_list: []) {
    try {
      await editDraftingProject({
        project_id: this.draftingProjectId,
        desc,
        sample_path: sample_path.map((item: any) => {
          return {
            name: item.name,
            url: item.url,
          }
        }),
      })
      await creatGalleryProject({
        platform_id: this.draftingOrder?.ticket_id,
        image_ids: image_list.map((item: any) => item._id),
      })
      this.draftingVisible = false
      this.$message.success('开始制图')
    } catch (error) {
      console.log(error)
    }
  }

  FormatAddOne(date: string) {
    return FormatAddOne(date)
  }

  /**
   * 分页触发的事件
   */
  changePage() {
    this.$nextTick(() => {
      if ((this.$refs.dataTable as any).bodyWrapper) {
        ;(this.$refs.dataTable as any).bodyWrapper.scrollTop = 0
      }
    })
  }
}
